import React, { useState } from 'react';

import { styled } from 'core/styles';
import { PositionFilters } from 'api/types';

import { Context, PositionsTable } from './PositionsTable';

type PositionsSectionProps = {
  filters: PositionFilters;
  context: Context;
  totalArchivePositions: number;
};

export function PositionsSection(props: PositionsSectionProps) {
  const { filters, context, totalArchivePositions } = props;

  const [visibleArchive, setVisibleArchive] = useState<boolean>(false);

  return (
    <TablesContainer>
      <PositionsTable
        filters={filters}
        context={context}
        isArchive={false}
        hideAmountColumns={false}
        title="Positions"
      />
      {totalArchivePositions > 0 && !visibleArchive && (
        <ArchivePositionsButton type="button" onClick={() => setVisibleArchive(true)}>
          Show {totalArchivePositions} archive positions
        </ArchivePositionsButton>
      )}
      {totalArchivePositions > 0 && visibleArchive && (
        <PositionsTable
          filters={filters}
          context={context}
          isArchive
          hideAmountColumns
          title="Archive positions"
        />
      )}
    </TablesContainer>
  );
}

const TablesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,

  '&:empty': {
    display: 'none',
  },
});

const ArchivePositionsButton = styled('button')(({ theme }) => ({
  padding: 0,
  margin: 0,
  background: 'transparent',
  cursor: 'pointer',
  border: 'none',
  color: theme.palette.text.secondary,
  textDecoration: 'underline',
  textAlign: 'start',
  transition: 'opacity 200ms',

  '&:hover': {
    opacity: 0.7,
  },
}));
